import React, { useEffect, useState } from 'react';
import { datetime } from "../../../../../util/library/datetime";
import { SHORT_TIME_FORMAT } from "../../../../../util/varibles/constants";
import styles from '../style.module.scss';

interface IProps {
}

const CurrentDay: React.FC<IProps> = () => {
    const [currentTime, setCurrentTime] = useState(Date.now());
    useEffect(() => {
        const interval = setInterval(() => setCurrentTime(Date.now()), 5000)
        return () => {
            if (interval)
                clearInterval(interval)
        };
    }, []);

    const style = { '--op-left': currentTime } as any

    return <div className={styles.currentTime} style={style}>
        <div className={styles.timeView}>{datetime(currentTime).format(SHORT_TIME_FORMAT)}</div>
    </div>;
};

export default CurrentDay;
